import React, { useState } from 'react';
import { Minus, Plus } from 'lucide-react';
import { faqs } from '../data/services';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white pb-16 lg:pb-24" data-id="element-23" data-mp="1lb91qzhuxkk4">
      <div className="mx-auto max-w-3xl px-5 lg:px-8" data-id="element-24" data-mp="1l9o8reb6y9od">
        <h2 className="font-display text-3xl leading-tight tracking-tight text-brand-navy sm:text-4xl" data-id="element-25" data-mp="1gdqqv3ka4v9h">
          QUESTIONS WE GET A LOT.
        </h2>
        <ul className="mt-8 divide-y divide-brand-navy/10 border-y border-brand-navy/10" data-id="element-26" data-mp="2dy3iblbjzzsb">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} data-id="element-27" data-mp="24437r3xi62c7" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left" data-id="element-28" data-mp="1z3yo551asrhr">
                  <span className="text-base font-bold text-brand-navy" data-id="element-29" data-mp="phxzdeh43rr9">
                    {faq.q}
                  </span>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-sky text-brand-blue" data-id="element-30" data-mp="uhaok5vghax0">
                    {isOpen ? <Minus className="h-4 w-4" aria-hidden="true" data-id="element-31" data-mp="kiuv3w8yhpkc" /> : <Plus className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="kko0z9bqw5ra" />}
                  </span>
                </button>
                {isOpen && <p className="pb-5 pr-12 text-base leading-relaxed text-brand-navy/70" data-id="element-33" data-mp="bjq0v24fgidz">
                    {faq.a}
                  </p>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}